import React, { Component } from 'react';
import { InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import {isNumber} from 'utils/IsNumber.js';

class ParameterMod extends Component {
    constructor(props) {
        super(props);

        this.state = {
            minValue: this.min,
            maxValue: this.max,
        };
    }

    get parameter() {
        return this.props.parameterMod.parameter;
    }

    get mod() {
        return this.props.parameterMod;
    }

    get min() {
        return this.mod.scale.min;
    }

    get max() {
        return this.mod.scale.max;
    }

    onChangeMin(min) {
        if (!isNumber(min) && min !== '.' && min !== '' && min !== '-') {
            return;
        }
        this.setState({minValue: min});
        if (isNumber(min)) {
            console.log('returning because = ' + min);
            this.mod.min = min;
        } else if (min === '.' || min === '' || min === '-') {
            this.mod.min = 0;
        }
    }

    onChangeMax(max) {
        if (!isNumber(max) && max !== '.' && max !== '' && max !== '-') {
            console.log('returning because = ' + max);
            return;
        }
        this.setState({maxValue: max});
        if (isNumber(max)) {
            this.mod.max = max;
        } else if (max === '.' || max === '' || max === '-') {
            this.mod.max = 0;
        }
    }

    render() {
        return (
            <div className="parameter-mod">
              <div className="parameter-mod-pieces">
                <div className="parameter-mod-modulator">{this.mod.type} {this.mod.modulator.number} </div>
                <div className="parameter-mod-text">mod</div>
                <div className="parameter-mod-parameter">{this.parameter.name} </div>
              </div>
              <div className="parameter-mod-min">Min:
                <NumberInput
                  placeholder="Min"
                  onChange={(v) => this.onChangeMin(v)}
                  number={this.state.minValue}/></div>
              <div className="parameter-mod-max">Max:
                <NumberInput
                  placeholder="Max"
                  onChange={(v) => this.onChangeMax(v)}
                  number={this.state.maxValue}/></div>
            </div>
        );
    }
}

class NumberInput extends Component {
    render() {
        return (
            <div className="number-input-container">
              <Input
                onChange={(event) => this.props.onChange(event.target.value)}
                value={this.props.number}
                className="search-input"
                placeholder={this.props.placeholder} className="number-input"/>
            </div>
        );
    }
}

export default ParameterMod;
